import {
  createRoute,
  lazyRouteComponent,
  notFound,
} from "@tanstack/react-router";
import { z } from "zod";
import { getFeatureFlags } from "../utils/posthog";
import { localeRoute } from "./locale";

const chatSearchSchema = z.object({
  messageId: z.string().optional(),
});

export const chatRoute = createRoute({
  getParentRoute: () => localeRoute,
  path: "/chat/$trackingId",
  validateSearch: (search: Record<string, unknown>) => {
    const result = chatSearchSchema.safeParse(search);
    return result.success ? result.data : { messageId: undefined };
  },
  component: lazyRouteComponent(() => import("../pages/chat-page")),
});
